module.exports = __webpack_public_path__ + "img/css-framework3.6cd091c2.png";